const closingAccordions = async (parent) => {
    const accordionsToClose = parent.querySelectorAll(".accordion-js-item.is-open")
    accordionsToClose.forEach((item) => {
        console.log(item)
        item.classList.remove("is-open")
        item.querySelector(".accordion-js-toggle").classList.remove("is-open")
        item.querySelector(".accordion-js-content").classList.remove("is-open")
    })
}

const initAccordions = () => {
    const accordionToggles = document.querySelectorAll(".accordion-js-toggle")
    if (!accordionToggles) { return }

    accordionToggles.forEach((accordionToggle) => {
        accordionToggle.addEventListener("click", async () => {
            const accordionContent = accordionToggle.parentElement.querySelector('.accordion-js-content')
            const accordionItem = accordionToggle.parentElement

            await closingAccordions(accordionToggle.closest(".accordion-js"))

            if (accordionToggle.classList.contains("is-open")) {
                accordionToggle.classList.remove("is-open")
                accordionContent.classList.remove("is-open")
                accordionItem.classList.remove("is-open")
            } else { 
                accordionToggle.classList.add("is-open")
                accordionContent.classList.add("is-open")
                accordionItem.classList.add("is-open")
            }
        });
    });
}

export { initAccordions }